// Mirrors: App\Enums\GuildRanks (core)
export const GuildRank = Object.freeze({
    INDEPENDENT: 0,
    MEMBER: 1,
    OFFICER: 2,
    LEADER: 3,
});
